import PropTypes from 'prop-types';

const OverlayTooltip = ({ paragraphs }) => (
  <ul className="tooltyp-content__list">
    {paragraphs.map(text => (
      <li key={text}>
        <strong>{text}</strong>
      </li>
    ))}
  </ul>
);

OverlayTooltip.propTypes = {
  paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default OverlayTooltip;
